export default __webpack_public_path__ + "static/media/BQ.5fbe11eb.svg";